import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import generateGrid from '../utils/generateGrid';
import '../pages/styles.css';
import ThemeToggle from '../components/ThemeToggle';

const BiblicalCrossword = ({ themeId = 'financas-lei-semeadura' }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // Capturar parâmetros da URL
  const urlTema = searchParams.get('tema');
  const urlPalavra = searchParams.get('palavra');

  // Alert para mostrar os parâmetros recebidos (para teste)
  // useEffect(() => {
  //   if (urlTema || urlPalavra) {
  //     const params = {
  //       tema: urlTema || 'não informado',
  //       palavra: urlPalavra || 'não informada'
  //     };
      
  //     // Log detalhado no console
  //     console.log('📊 === PARÂMETROS URL RECEBIDOS ===');
  //     console.log('📂 Tema:', params.tema);
  //     console.log('🔤 Palavra:', params.palavra);
  //     console.log('🌐 URL completa:', window.location.href);
  //     console.log('🔍 Search params object:', Object.fromEntries(searchParams));
  //     console.log('===============================');
      
  //     // Alert para visualização rápida
  //     const fileName = urlTema === 'prosperidade' && urlPalavra 
  //       ? `${urlTema}_${urlPalavra}.json`
  //       : `${urlTema}.json`;
      
  //     alert(`🔍 PARÂMETROS RECEBIDOS:\n\nTema: ${params.tema}\nPalavra: ${params.palavra}\n\n📁 Arquivo: ${fileName}\n\n🔧 Lógica: ${urlTema === 'prosperidade' ? 'CONCATENAÇÃO ativada' : 'PADRÃO'}\n\nURL: ${window.location.href}\n\nVerifique o console!`);
  //   } else {
  //     console.log('ℹ️ Nenhum parâmetro URL detectado');
  //   }
  // }, [urlTema, urlPalavra, searchParams]);

  // Estado para controlar o tema atual
  const [currentThemeId, setCurrentThemeId] = useState(urlTema || themeId);

  // Sequência de temas em ordem
  const themeSequence = [
    'financas-lei-semeadura',
    'poder-gratidao'
    // Adicione mais temas aqui conforme criar
  ];

  // Função para obter o próximo tema
  const getNextTheme = () => {
    const currentIndex = themeSequence.indexOf(currentThemeId);
    if (currentIndex !== -1 && currentIndex < themeSequence.length - 1) {
      return themeSequence[currentIndex + 1];
    }
    return null; // Não há próximo tema
  };

  // Função para ir para o próximo tema
  const goToNextTheme = async () => {
    const nextTheme = getNextTheme();
    if (nextTheme) {
      console.log('🔄 Carregando próximo tema:', nextTheme);
      
      // Resetar estados do jogo atual
      setFound([]);
      setFoundWords([]);
      setFoundPositions([]);
      setSelected([]);
      setGameComplete(false);
      setShowDefinitionModal(false);
      setSelectedWordData(null);
      
      // Atualizar tema atual
      setCurrentThemeId(nextTheme);
      
      // Carregar dados do novo tema
      await loadThemeData(nextTheme);
    }
  };

  // Função para carregar dados do tema
  const loadThemeData = async (themeIdToLoad) => {
    // Lógica especial para tema "prosperidade"
    let fileName = themeIdToLoad;
    
    if (urlTema === 'prosperidade' && urlPalavra) {
      fileName = `${urlTema}_${urlPalavra}`;
      console.log('🔄 TEMA PROSPERIDADE DETECTADO - Arquivo concatenado:', fileName);
    }
    
    try {
      console.log('📥 Carregando tema:', themeIdToLoad);
      console.log('📁 Arquivo a ser carregado:', `${fileName}.json`);
      
      const response = await fetch(`/data/crossword-themes/${fileName}.json`);
      if (!response.ok) {
        throw new Error(`Tema não encontrado: ${fileName}`);
      }
      const data = await response.json();
      console.log('✅ Tema carregado:', data.theme?.title || 'Sem título');
      console.log('📝 Palavras:', data.words?.map(w => w.word) || 'Sem palavras');

      setThemeData(data);
      setWords(data.words.map(w => w.word.toUpperCase()));
      
      // Criar dicionário de definições
      const definitions = {};
      data.words.forEach(wordObj => {
        definitions[wordObj.word.toUpperCase()] = wordObj;
      });
      setWordDefinitions(definitions);
      
      // Gerar nova grade
      setTimeout(() => {
        const gridSettings = data?.grid_settings || { rows: 12, cols: 9 };
        generateGridWithAllWords(data.words.map(w => w.word.toUpperCase()), gridSettings.rows, gridSettings.cols);
        setIsLoaded(true);
      }, 100);
      
    } catch (error) {
      console.error('❌ Erro ao carregar tema:', error);
      console.error('📁 Tentativa de arquivo:', `${fileName}.json`);
    }
  };
  
  // Função para verificar acesso Premium
  const checkPremiumAccess = async (email) => {
    setPremiumCheckLoading(true);
    try {
      console.log('🔍 Verificando acesso Premium para:', email);
      
      // Primeiro, tentar fazer login para obter o token
      const loginResponse = await fetch('https://dropsebook.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          productId: 6160568 // ID do Premium
        })
      });
      
      const loginData = await loginResponse.json();
      console.log('📊 Resposta do login:', loginData);
      
      if (loginData.success && loginData.token) {
        // Se login foi bem-sucedido, verificar acesso
        const verifyResponse = await fetch('https://dropsebook.com/api/verify-access', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${loginData.token}`
          },
          body: JSON.stringify({
            productId: 6160568 // ID do Premium
          })
        });
        
        const verifyData = await verifyResponse.json();
        console.log('📊 Resposta da verificação de acesso:', verifyData);
        
        if (verifyData.hasAccess) {
          setIsPremiumUser(true);
          setUserEmail(email);
          console.log('✅ Usuário tem acesso Premium!');
          return true;
        }
      }
      
      // Se chegou aqui, não tem acesso
      setIsPremiumUser(false);
      console.log('❌ Usuário NÃO tem acesso Premium');
      return false;
      
    } catch (error) {
      console.error('❌ Erro ao verificar acesso Premium:', error);
      setIsPremiumUser(false);
      return false;
    } finally {
      setPremiumCheckLoading(false);
    }
  };

  // Função para extrair email dos parâmetros da URL
  const extractEmailFromUrl = () => {
    const email = searchParams.get('email');
    if (email) {
      console.log('📧 Email extraído da URL:', email);
      setUserEmail(email);
      return email;
    }
    console.log('❌ Nenhum email encontrado na URL');
    return null;
  };

  // Verificar acesso Premium ao carregar o componente
  useEffect(() => {
    const email = extractEmailFromUrl();
    if (email) {
      checkPremiumAccess(email);
    }
  }, [searchParams]);

  // Função para resetar o jogo (agora com verificação Premium)
  const resetGamePremium = async () => {
    const email = userEmail || extractEmailFromUrl();
    
    if (!email) {
      setShowPremiumModal(true);
      return;
    }
    
    const hasAccess = await checkPremiumAccess(email);
    if (hasAccess) {
      resetGame();
    } else {
      setShowPremiumModal(true);
    }
  };
  
  // Estados do jogo
  const [selected, setSelected] = useState([]);
  const [found, setFound] = useState([]);
  const [foundPositions, setFoundPositions] = useState([]); // Posições específicas das células encontradas
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [foundWords, setFoundWords] = useState([]);
  const [gameComplete, setGameComplete] = useState(false);
  const [grid, setGrid] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [wordFoundMessage, setWordFoundMessage] = useState(''); // Feedback para mobile
  const [isTestMode, setIsTestMode] = useState(false); // Modo de teste para desenvolvimento
  
  // Estados para dados dinâmicos
  const [themeData, setThemeData] = useState(null);
  const [words, setWords] = useState([]);
  const [wordDefinitions, setWordDefinitions] = useState({});
  const [showDefinitionModal, setShowDefinitionModal] = useState(false);
  const [selectedWordData, setSelectedWordData] = useState(null);

  // Estados para verificação Premium
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [premiumCheckLoading, setPremiumCheckLoading] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  // Carregamento dinâmico do tema
  useEffect(() => {
    loadThemeData(currentThemeId);
  }, [currentThemeId]); // Dependência do tema atual

  useEffect(() => {
    // Detectar se é dispositivo móvel
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // PREVENIR PULL-TO-REFRESH E OUTROS GESTOS NO MOBILE
    if (isMobile) {
      // Desabilitar pull-to-refresh
      document.body.style.overscrollBehavior = 'none';
      document.documentElement.style.overscrollBehavior = 'none';
      
      // Prevenir zoom e outros gestos indesejados
      document.body.style.touchAction = 'pan-y pinch-zoom';
      
      // Adicionar meta tag para prevenir zoom
      let viewportMeta = document.querySelector('meta[name="viewport"]');
      if (!viewportMeta) {
        viewportMeta = document.createElement('meta');
        viewportMeta.name = 'viewport';
        document.head.appendChild(viewportMeta);
      }
      viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    }
    
    // Adicionar animação CSS para o feedback
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeInOut {
        0% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
        20% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        80% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        100% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
      }

      @keyframes modalFadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
      }

      @keyframes modalSlideIn {
        0% { transform: scale(0.7) translateY(50px); opacity: 0; }
        100% { transform: scale(1) translateY(0); opacity: 1; }
      }

      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
        40% { transform: translateY(-15px); }
        60% { transform: translateY(-8px); }
      }
      
      /* Prevenir pull-to-refresh no mobile */
      body {
        overscroll-behavior: none;
      }
      
      /* Melhorar touch responsiveness */
      .crossword-grid {
        touch-action: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        user-select: none;
      }
    `;
    document.head.appendChild(style);
    
    // Verificar se o modo escuro está ativo
    setIsDarkMode(document.body.classList.contains('dark-theme'));
    
    // Gerar a grade apenas uma vez quando o componente for montado (12x9 - otimizado para mobile)
    if (!grid && words.length > 0) {
      const gridSettings = themeData?.grid_settings || { rows: 12, cols: 9 };
      generateGridWithAllWords(words, gridSettings.rows, gridSettings.cols);
    }
    
    // Configurar observador para mudanças no modo escuro
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.attributeName === 'class' &&
          mutation.target === document.body
        ) {
          setIsDarkMode(document.body.classList.contains('dark-theme'));
        }
      });
    });
    
    observer.observe(document.body, { attributes: true });
    
    // Efeito de carregamento suave
    setTimeout(() => {
      setIsLoaded(true);
    }, 300);
    
    // Rolar para o topo
    window.scrollTo(0, 0);
    
    // Função para prevenir pull-to-refresh globalmente
    const preventPullToRefresh = (e) => {
      // Se estamos no topo da página e tentando scrollar para cima
      if (window.scrollY === 0 && e.deltaY < 0) {
        e.preventDefault();
      }
    };

    const preventTouchMove = (e) => {
      // Se o touch está acontecendo dentro da grade do jogo
      if (e.target.closest('.crossword-grid') && isMouseDown) {
        e.preventDefault();
      }
    };

    // Adicionar listeners globais no mobile
    if (isMobile) {
      document.addEventListener('wheel', preventPullToRefresh, { passive: false });
      document.addEventListener('touchmove', preventTouchMove, { passive: false });
    }
    
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkMobile);
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
      // Remover listeners globais
      if (isMobile) {
        document.removeEventListener('wheel', preventPullToRefresh);
        document.removeEventListener('touchmove', preventTouchMove);
        // Restaurar configurações originais
        document.body.style.overscrollBehavior = '';
        document.documentElement.style.overscrollBehavior = '';
        document.body.style.touchAction = '';
      }
    };
  }, [grid, words, themeData]);

  // Verificar se o jogo foi completado
  useEffect(() => {
    if (words.length > 0 && foundWords.length === words.length) {
      setGameComplete(true);
    }
  }, [foundWords.length, words.length]);

  // Função para criar efeito de confete
  function createConfettiEffect() {
    const confettiEmojis = ['🎉', '🎊', '✨', '🌟', '⭐', '💫', '🎈', '🏆'];
    
    for (let i = 0; i < 15; i++) {
      setTimeout(() => {
        const confetti = document.createElement('div');
        confetti.innerHTML = confettiEmojis[Math.floor(Math.random() * confettiEmojis.length)];
        confetti.style.position = 'fixed';
        confetti.style.left = Math.random() * 100 + 'vw';
        confetti.style.top = '-10px';
        confetti.style.fontSize = (Math.random() * 20 + 15) + 'px';
        confetti.style.zIndex = '9999';
        confetti.style.pointerEvents = 'none';
        confetti.style.animation = `confettiFall ${Math.random() * 2 + 2}s ease-out forwards`;
        
        document.body.appendChild(confetti);
        
        setTimeout(() => {
          if (document.body.contains(confetti)) {
            document.body.removeChild(confetti);
          }
        }, 4000);
      }, i * 100);
    }
  }

  function handleMouseDown(r, c) {
    console.log('Mouse/Touch down at:', r, c); // Debug
    setIsMouseDown(true);
    setSelected([[r, c]]);
  }

  function handleMouseEnter(r, c) {
    if (isMouseDown) {
      console.log('Mouse/Touch enter at:', r, c); // Debug
      
      // Verificar se essa posição já foi selecionada para evitar duplicatas
      const alreadySelected = selected.some(([sr, sc]) => sr === r && sc === c);
      if (!alreadySelected) {
        setSelected((prev) => [...prev, [r, c]]);
      }
    }
  }

  function handleMouseUp() {
    console.log('🔥 handleMouseUp called!'); // Debug principal
    console.log('🎯 Mouse down state:', isMouseDown); // Debug estado
    console.log('📍 Selected positions:', selected); // Debug seleção
    
    if (selected.length === 0) {
      console.log('❌ No selection, aborting...'); // Debug
      setIsMouseDown(false);
      return;
    }
    
    setIsMouseDown(false);

    const letters = selected.map(([r, c]) => grid[r][c]).join("");
    const reversed = letters.split("").reverse().join("");

    console.log('🔤 Letters formed:', letters, '| Reversed:', reversed); // Debug
    console.log('📚 Available words:', words); // Debug

    if (words.includes(letters) || words.includes(reversed)) {
      const foundWord = words.includes(letters) ? letters : reversed;
      console.log('✅ Word found:', foundWord); // Debug
      
      if (!foundWords.includes(foundWord)) {
        console.log('🎉 New word! Adding to found words...'); // Debug
        
        // Armazenar as posições EXATAS das células que formam a palavra (converter para formato {r, c})
        const wordPositions = selected.map(([r, c]) => ({r, c})); // Converter array para objeto
        setFound((prev) => [...prev, letters, reversed]);
        setFoundWords((prev) => [...prev, foundWord]);
        setFoundPositions((prev) => {
          const newPositions = [...prev, ...wordPositions];
          console.log('📍 Posições totais após adicionar', foundWord, ':', newPositions); // Debug
          return newPositions;
        });
        
        console.log('📍 Posições da palavra encontrada:', wordPositions); // Debug
        
        // Efeitos de celebração
        // Vibração no mobile (se suportado)
        if (navigator.vibrate && isMobile) {
          console.log('📳 Vibrating...'); // Debug
          navigator.vibrate([100, 50, 100]);
        }
        
        // Criar efeito de confete
        createConfettiEffect();
        
        // Mostrar modal de definição da palavra
        const wordData = wordDefinitions[foundWord];
        if (wordData) {
          console.log('📖 Showing definition modal for:', foundWord); // Debug
          setSelectedWordData({
            word: foundWord,
            ...wordData
          });
          setShowDefinitionModal(true);
        } else {
          console.log('❓ No definition found for:', foundWord); // Debug
          // Fallback para feedback simples se não houver definição
          if (isMobile) {
            setWordFoundMessage(`🎉 ${foundWord} encontrada!`);
            setTimeout(() => setWordFoundMessage(''), 3000);
          } else {
            setTimeout(() => {
              alert(`Parabéns! Você encontrou: ${foundWord}! 🎉`);
            }, 100);
          }
        }
      } else {
        console.log('🔄 Word already found:', foundWord); // Debug
      }
    } else {
      console.log('❌ No valid word found with:', letters, 'or', reversed); // Debug
    }

    setSelected([]);
        console.log('🧹 Selection cleared!'); // Debug
  }

  // Função para gerar grade garantindo que todas as palavras sejam colocadas
  function generateGridWithAllWords(wordList, rows, cols, maxAttempts = 10) {
    console.log(`🔄 Tentando gerar grade ${rows}x${cols} com ${wordList.length} palavras...`);
    
    let attempts = 0;
    let bestGrid = null;
    let bestWordCount = 0;
    
    while (attempts < maxAttempts) {
      attempts++;
      console.log(`🎲 Tentativa ${attempts}/${maxAttempts}`);
      
      const currentGrid = generateGrid(wordList, rows, cols);
      const wordsInGrid = verifyWordsInGridCount(currentGrid, wordList);
      
      console.log(`📊 Tentativa ${attempts}: ${wordsInGrid}/${wordList.length} palavras colocadas`);
      
      if (wordsInGrid === wordList.length) {
        console.log('✅ SUCESSO! Todas as palavras foram colocadas na grade!');
        setGrid(currentGrid);
        
        // Verificação detalhada
        setTimeout(() => {
          verifyWordsInGrid(currentGrid, wordList);
        }, 100);
        
        return;
      }
      
      // Manter a melhor grade até agora
      if (wordsInGrid > bestWordCount) {
        bestWordCount = wordsInGrid;
        bestGrid = currentGrid;
      }
    }
    
    // Se não conseguiu colocar todas, usar a melhor tentativa
    console.warn(`⚠️ Não foi possível colocar todas as palavras após ${maxAttempts} tentativas.`);
    console.warn(`📉 Melhor resultado: ${bestWordCount}/${wordList.length} palavras`);
    console.warn('💡 Considere aumentar o tamanho da grade ou reduzir o número de palavras.');
    
    setGrid(bestGrid);
    
    // Verificação detalhada da melhor grade
    setTimeout(() => {
      verifyWordsInGrid(bestGrid, wordList);
    }, 100);
  }

  // Função para contar rapidamente quantas palavras estão na grade
  function verifyWordsInGridCount(grid, wordList) {
    if (!grid) return 0;
    
    let count = 0;
    wordList.forEach(word => {
      const positions = findWordPositionsInGridStatic(grid, word);
      if (positions.length > 0) {
        count++;
      }
    });
    
    return count;
  }

  // Função para verificar se todas as palavras estão na grade
  function verifyWordsInGrid(grid, wordList) {
    console.log('🔍 VERIFICAÇÃO: Palavras esperadas:', wordList);
    
    const foundInGrid = [];
    const notFoundInGrid = [];
    
    wordList.forEach(word => {
      const positions = findWordPositionsInGridStatic(grid, word);
      if (positions.length > 0) {
        foundInGrid.push(word);
        console.log(`✅ ENCONTRADA: ${word} nas posições:`, positions);
      } else {
        notFoundInGrid.push(word);
        console.log(`❌ NÃO ENCONTRADA: ${word}`);
      }
    });
    
    console.log('📊 RESUMO DA VERIFICAÇÃO:');
    console.log(`✅ Palavras encontradas (${foundInGrid.length}/${wordList.length}):`, foundInGrid);
    console.log(`❌ Palavras não encontradas (${notFoundInGrid.length}/${wordList.length}):`, notFoundInGrid);
    
    if (notFoundInGrid.length > 0) {
      console.warn('⚠️ ATENÇÃO: Algumas palavras não foram colocadas na grade!');
      console.warn('💡 Isso pode indicar que a grade é muito pequena ou há conflitos de colocação.');
    }
  }

  // Função auxiliar para buscar palavras na grade (versão estática)
  function findWordPositionsInGridStatic(grid, word) {
    if (!grid) return [];
    
    const wordUpper = word.toUpperCase();
    
    // Buscar horizontalmente (esquerda para direita)
    for (let r = 0; r < grid.length; r++) {
      for (let c = 0; c <= grid[r].length - wordUpper.length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r][c + i] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r, c: c + i});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar horizontalmente (direita para esquerda)
    for (let r = 0; r < grid.length; r++) {
      for (let c = grid[r].length - 1; c >= wordUpper.length - 1; c--) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r][c - i] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r, c: c - i});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar verticalmente (cima para baixo)
    for (let r = 0; r <= grid.length - wordUpper.length; r++) {
      for (let c = 0; c < grid[0].length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r + i][c] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r: r + i, c});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar verticalmente (baixo para cima)
    for (let r = grid.length - 1; r >= wordUpper.length - 1; r--) {
      for (let c = 0; c < grid[0].length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r - i][c] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r: r - i, c});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    return [];
  }

  function findWordPositionsInGrid(word) {
    if (!grid) return [];
    
    const positions = [];
    const wordUpper = word.toUpperCase();
    
    // Buscar horizontalmente (esquerda para direita)
    for (let r = 0; r < grid.length; r++) {
      for (let c = 0; c <= grid[r].length - wordUpper.length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r][c + i] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r, c: c + i});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar horizontalmente (direita para esquerda)
    for (let r = 0; r < grid.length; r++) {
      for (let c = grid[r].length - 1; c >= wordUpper.length - 1; c--) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r][c - i] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r, c: c - i});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar verticalmente (cima para baixo)
    for (let r = 0; r <= grid.length - wordUpper.length; r++) {
      for (let c = 0; c < grid[0].length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r + i][c] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r: r + i, c});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    // Buscar verticalmente (baixo para cima)
    for (let r = grid.length - 1; r >= wordUpper.length - 1; r--) {
      for (let c = 0; c < grid[0].length; c++) {
        let match = true;
        const currentPositions = [];
        
        for (let i = 0; i < wordUpper.length; i++) {
          if (grid[r - i][c] !== wordUpper[i]) {
            match = false;
            break;
          }
          currentPositions.push({r: r - i, c});
        }
        
        if (match) {
          return currentPositions;
        }
      }
    }
    
    return [];
  }

  // Função para simular descoberta de palavra (modo teste)
  function simulateWordDiscovery(word) {
    console.log('🧪 TESTE: Simulando descoberta da palavra:', word); // Debug
    
    if (!foundWords.includes(word)) {
      console.log('🎉 TESTE: Nova palavra! Adicionando...'); // Debug
      
      // Encontrar as posições corretas da palavra na grade
      const wordPositions = findWordPositionsInGrid(word);
      console.log('📍 TESTE: Posições encontradas para', word, ':', wordPositions); // Debug
      
      if (wordPositions.length > 0) {
        // Marcar palavra como encontrada
        setFound((prev) => [...prev, word]);
        setFoundWords((prev) => [...prev, word]);
        setFoundPositions((prev) => {
          const newPositions = [...prev, ...wordPositions];
          console.log('📍 TESTE: Posições totais após adicionar', word, ':', newPositions); // Debug
          return newPositions;
        });
        
        // Efeitos de celebração
        if (navigator.vibrate && isMobile) {
          console.log('📳 TESTE: Vibrando...'); // Debug
          navigator.vibrate([100, 50, 100]);
        }
        
        // Criar efeito de confete
        createConfettiEffect();
        
        // Mostrar modal de definição da palavra
        const wordData = wordDefinitions[word];
        if (wordData) {
          console.log('📖 TESTE: Mostrando modal para:', word); // Debug
          setSelectedWordData({
            word: word,
            ...wordData
          });
          setShowDefinitionModal(true);
        } else {
          console.log('❓ TESTE: Sem definição para:', word); // Debug
          if (isMobile) {
            setWordFoundMessage(`🎉 ${word} encontrada!`);
            setTimeout(() => setWordFoundMessage(''), 3000);
          } else {
            setTimeout(() => {
              alert(`Parabéns! Você encontrou: ${word}! 🎉`);
            }, 100);
          }
        }
      } else {
        console.log('⚠️ TESTE: Palavra não encontrada na grade:', word); // Debug
      }
    } else {
      console.log('🔄 TESTE: Palavra já encontrada:', word); // Debug
    }
  }

  function isSelected(r, c) {
    return selected.some(([sr, sc]) => sr === r && sc === c);
  }

  function isFound(r, c) {
    // Verificar se a posição [r, c] está nas posições encontradas
    return foundPositions.some(pos => pos.r === r && pos.c === c);
  }

  function resetGame() {
    setFound([]);
    setFoundWords([]);
    setFoundPositions([]);  // Limpar posições encontradas também
    setSelected([]);
    setGameComplete(false);
    // Gerar nova grade garantindo que todas as palavras sejam colocadas (12x9 - mobile otimizado)
    generateGridWithAllWords(words, 12, 9);
  }

  return (
    <div className={`page-container ${isDarkMode ? 'dark' : 'light'}`}>
      <ThemeToggle />
      
      <div className={`page-content ${isLoaded ? 'loaded' : ''}`} style={{
        maxWidth: isMobile ? '100%' : '1200px',
        margin: '0 auto',
        padding: isMobile ? '0 10px' : '0 20px'
      }}>
        {/* Cabeçalho */}
        <section className="hero-section" style={{
          background: isDarkMode 
            ? 'linear-gradient(135deg, #1e3a8a, #312e81)' 
            : 'linear-gradient(135deg, #2563eb, #4338ca)',
          padding: isMobile ? '0.5rem 0.75rem' : '2rem 1.5rem',
          borderRadius: '8px',
          marginBottom: isMobile ? '0.5rem' : '2rem',
          color: 'white',
          textAlign: 'center'
        }}>
          <h1 style={{ 
            fontSize: isMobile ? '1.1rem' : '2.5rem', 
            fontWeight: 'bold',
            marginBottom: isMobile ? '0.25rem' : '1rem'
          }}>
            🔍 Palavras Cruzadas
          </h1>
          
          {!isMobile && (
            <p style={{ 
              fontSize: '1.2rem',
              maxWidth: '600px',
              margin: '0 auto 1rem',
              lineHeight: '1.4'
            }}>
              Encontre as palavras sagradas! Use o mouse para selecionar.
            </p>
          )}

          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '0.5rem',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            {/* <button 
              onClick={() => navigate('/')}
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '4px',
                padding: isMobile ? '0.3rem 0.6rem' : '0.5rem 1rem',
                cursor: 'pointer',
                fontSize: isMobile ? '0.7rem' : '1rem'
              }}
            >
              ← Início
            </button> */}

            <button 
              onClick={resetGamePremium}
              disabled={premiumCheckLoading}
              style={{
                background: isPremiumUser 
                  ? 'linear-gradient(135deg, #fbbf24, #f59e0b)' 
                  : 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                border: isPremiumUser 
                  ? '2px solid #fbbf24' 
                  : '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '6px',
                padding: isMobile ? '0.4rem 0.8rem' : '0.5rem 1rem',
                cursor: premiumCheckLoading ? 'wait' : 'pointer',
                fontSize: isMobile ? '0.8rem' : '1rem',
                marginRight: '0.5rem',
                fontWeight: 'bold',
                boxShadow: isPremiumUser 
                  ? '0 4px 12px rgba(251, 191, 36, 0.3)' 
                  : 'none',
                opacity: premiumCheckLoading ? 0.7 : 1,
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem'
              }}
            >
              {premiumCheckLoading ? (
                <>⏳ Verificando...</>
              ) : (
                <>
                  🔄 Novo
                  <span style={{
                    background: isPremiumUser ? '#f59e0b' : '#ef4444',
                    padding: '0.1rem 0.3rem',
                    borderRadius: '3px',
                    fontSize: isMobile ? '0.6rem' : '0.7rem',
                    marginLeft: '0.2rem'
                  }}>
                    {isPremiumUser ? '👑 PREMIUM' : '🔒 PREMIUM'}
                  </span>
                </>
              )}
            </button>

            {/* <button 
              onClick={() => setIsTestMode(!isTestMode)}
              style={{
                background: isTestMode ? 'rgba(34, 197, 94, 0.3)' : 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                border: isTestMode ? '1px solid rgba(34, 197, 94, 0.5)' : '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '6px',
                padding: isMobile ? '0.4rem 0.8rem' : '0.5rem 1rem',
                cursor: 'pointer',
                fontSize: isMobile ? '0.8rem' : '1rem'
              }}
            >
              🧪 {isTestMode ? 'Sair do Teste' : 'Modo Teste'}
            </button>

            <button 
              onClick={() => {
                // Simular parâmetros para teste com tema prosperidade
                const testUrl = `${window.location.origin}${window.location.pathname}?tema=prosperidade&palavra=gratidao`;
                window.location.href = testUrl;
              }}
              style={{
                background: 'rgba(255, 165, 0, 0.3)',
                color: 'white',
                border: '1px solid rgba(255, 165, 0, 0.5)',
                borderRadius: '6px',
                padding: isMobile ? '0.4rem 0.8rem' : '0.5rem 1rem',
                cursor: 'pointer',
                fontSize: isMobile ? '0.8rem' : '1rem',
                marginLeft: '0.5rem'
              }}
            >
              🔗 Testar Prosperidade
            </button> */}
          </div>
        </section>

        {/* Banner de Debug - Parâmetros da URL */}
        {/* {(urlTema || urlPalavra) && (
          <div style={{
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            color: 'white',
            padding: isMobile ? '0.8rem' : '1rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            animation: 'pulsate 2s ease-in-out infinite'
          }}>
            <div style={{
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: 'bold',
              marginBottom: '0.5rem'
            }}>
              🔗 PARÂMETROS RECEBIDOS VIA URL
            </div>
            <div style={{
              fontSize: isMobile ? '0.8rem' : '0.9rem',
              opacity: 0.9,
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '1rem',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <span>📂 <strong>Tema:</strong> {urlTema || 'não informado'}</span>
              <span>🔤 <strong>Palavra:</strong> {urlPalavra || 'não informada'}</span>
            </div>
            <div style={{
              fontSize: '0.7rem',
              marginTop: '0.5rem',
              opacity: 0.8,
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              padding: '0.3rem 0.6rem',
              borderRadius: '4px',
              display: 'inline-block'
            }}>
              📁 Arquivo: {urlTema === 'prosperidade' && urlPalavra ? `${urlTema}_${urlPalavra}.json` : `${urlTema || currentThemeId}.json`}
            </div>
            <div style={{
              fontSize: '0.6rem',
              marginTop: '0.3rem',
              opacity: 0.7
            }}>
              URL: {window.location.href}
            </div>
          </div>
        )} */}

        {/* Banner do Modo Teste */}
        {/* {isTestMode && (
          <div style={{
            background: 'linear-gradient(135deg, #22c55e, #16a34a)',
            color: 'white',
            padding: isMobile ? '0.8rem' : '1rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(34, 197, 94, 0.3)',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            animation: 'pulsate 2s ease-in-out infinite'
          }}>
            <div style={{
              fontSize: isMobile ? '1rem' : '1.1rem',
              fontWeight: 'bold',
              marginBottom: '0.5rem'
            }}>
              🧪 MODO TESTE ATIVO
            </div>
            <div style={{
              fontSize: isMobile ? '0.8rem' : '0.9rem',
              opacity: 0.9
            }}>
              Clique nas palavras da lista para simular sua descoberta e testar o modal!
            </div>
          </div>
        )} */}

        {/* Mensagem de feedback para mobile */}
        {wordFoundMessage && (
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: isDarkMode ? '#10b981' : '#22c55e',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '12px',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            zIndex: 1000,
            boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
            animation: 'fadeInOut 3s ease-in-out forwards'
          }}>
            {wordFoundMessage}
          </div>
        )}

        {/* Área do jogo */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '1rem' : '2rem',
          alignItems: isMobile ? 'center' : 'flex-start',
          justifyContent: 'center'
        }}>
          {/* Grade do jogo */}
          {grid && (
            <div style={{
              background: isDarkMode ? '#1f2937' : '#ffffff',
              borderRadius: '12px',
              padding: isMobile ? '1rem' : '2rem',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              overflow: 'auto',
              maxWidth: '100%'
            }}>
            <div
              style={{
                display: 'grid',
                gap: isMobile ? '1px' : '2px',
                gridTemplateColumns: `repeat(${grid[0].length}, ${isMobile ? '2.2rem' : '2.5rem'})`,
                userSelect: 'none',
                touchAction: 'none',
                overscrollBehavior: 'none',
                WebkitOverscrollBehavior: 'none'
              }}
              className="crossword-grid"
              onMouseUp={handleMouseUp}
              onTouchEnd={(e) => {
                // Restaurar scroll após qualquer touch
                setTimeout(() => {
                  document.body.style.overflow = '';
                }, 100);
                handleMouseUp();
              }}
              onContextMenu={(e) => e.preventDefault()} // Prevenir menu de contexto
            >
                {grid.map((row, r) =>
                  row.map((letter, c) => (
                    <div
                      key={`${r}-${c}`}
                      onMouseDown={() => handleMouseDown(r, c)}
                      onMouseEnter={() => handleMouseEnter(r, c)}
                      onTouchStart={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        // Prevenir scroll durante o touch
                        document.body.style.overflow = 'hidden';
                        handleMouseDown(r, c);
                      }}
                      onTouchMove={(e) => {
                        if (!isMouseDown) return;
                        
                        e.preventDefault();
                        e.stopPropagation();
                        
                        const touch = e.touches[0];
                        const element = document.elementFromPoint(touch.clientX, touch.clientY);
                        if (element && element.dataset.coords) {
                          const [touchR, touchC] = element.dataset.coords.split('-').map(Number);
                          
                          // Só chamar handleMouseEnter se for uma posição diferente da última
                          const lastSelected = selected[selected.length - 1];
                          if (!lastSelected || lastSelected[0] !== touchR || lastSelected[1] !== touchC) {
                            handleMouseEnter(touchR, touchC);
                          }
                        }
                      }}
                      data-coords={`${r}-${c}`}
                      style={{
                        width: isMobile ? '2.2rem' : '2.5rem',
                        height: isMobile ? '2.2rem' : '2.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `2px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '0.9rem' : '1rem',
                        backgroundColor: isFound(r, c)
                          ? (isDarkMode ? '#10b981' : '#22c55e')
                          : isSelected(r, c)
                          ? (isDarkMode ? '#fbbf24' : '#fde047')
                          : (isDarkMode ? '#374151' : '#f9fafb'),
                        color: isFound(r, c)
                          ? 'white'
                          : isSelected(r, c)
                          ? (isDarkMode ? '#000' : '#000')
                          : (isDarkMode ? '#e5e7eb' : '#1f2937'),
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {letter}
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* Painel lateral */}
          <div style={{
            width: isMobile ? '100%' : '250px',
            maxWidth: isMobile ? '400px' : '250px',
            display: 'flex',
            flexDirection: isMobile ? 'row' : 'column',
            gap: isMobile ? '0.75rem' : '1.5rem',
            justifyContent: isMobile ? 'space-between' : 'flex-start'
          }}>
            {/* Progresso */}
            <div style={{
              background: isDarkMode ? '#1f2937' : '#ffffff',
              borderRadius: '8px',
              padding: isMobile ? '0.75rem' : '1.5rem',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              flex: isMobile ? '1' : 'none'
            }}>
              <h3 style={{ 
                margin: '0 0 0.75rem 0',
                color: isDarkMode ? '#e5e7eb' : '#1f2937',
                fontSize: isMobile ? '0.9rem' : '1.2rem',
                fontWeight: 'bold'
              }}>
                📊 {isMobile ? '' : 'Progresso'}
              </h3>
              
              <div style={{
                background: isDarkMode ? '#374151' : '#f3f4f6',
                borderRadius: '6px',
                padding: '0.4rem',
                marginBottom: isMobile ? '0.5rem' : '1rem'
              }}>
                <div style={{
                  background: isDarkMode ? '#10b981' : '#22c55e',
                  height: isMobile ? '6px' : '8px',
                  borderRadius: '3px',
                  width: `${(foundWords.length / words.length) * 100}%`,
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
              
              <p style={{ 
                margin: 0,
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                textAlign: 'center',
                fontSize: isMobile ? '0.8rem' : '1rem'
              }}>
                {foundWords.length}/{words.length}
              </p>
            </div>

            {/* Lista de palavras */}
            <div style={{
              background: isDarkMode ? '#1f2937' : '#ffffff',
              borderRadius: '8px',
              padding: isMobile ? '0.75rem' : '1.5rem',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              flex: isMobile ? '2' : 'none'
            }}>
              <h3 style={{ 
                margin: '0 0 0.75rem 0',
                color: isDarkMode ? '#e5e7eb' : '#1f2937',
                fontSize: isMobile ? '0.9rem' : '1.2rem',
                fontWeight: 'bold'
              }}>
                📝 Palavras
              </h3>
              
              <div style={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'row' : 'column',
                flexWrap: isMobile ? 'wrap' : 'nowrap',
                gap: isMobile ? '0.3rem' : '0.5rem'
              }}>
                {words.map((word, index) => (
                  <div 
                    key={index}
                    onClick={() => {
                      if (isTestMode && !foundWords.includes(word)) {
                        simulateWordDiscovery(word);
                      }
                    }}
                    style={{
                      padding: isMobile ? '0.2rem 0.4rem' : '0.5rem',
                      borderRadius: '4px',
                      backgroundColor: foundWords.includes(word)
                        ? (isDarkMode ? 'rgba(16, 185, 129, 0.3)' : 'rgba(34, 197, 94, 0.2)')
                        : (isDarkMode ? '#374151' : '#f9fafb'),
                      color: foundWords.includes(word)
                        ? (isDarkMode ? '#6ee7b7' : '#15803d')
                        : (isDarkMode ? '#d1d5db' : '#4b5563'),
                      textDecoration: foundWords.includes(word) ? 'line-through' : 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.2rem',
                      fontSize: isMobile ? '0.7rem' : '0.9rem',
                      flex: isMobile ? '0 0 auto' : 'none',
                      whiteSpace: 'nowrap',
                      cursor: (isTestMode && !foundWords.includes(word)) ? 'pointer' : 'default',
                      border: (isTestMode && !foundWords.includes(word)) 
                        ? '2px dashed rgba(34, 197, 94, 0.5)' 
                        : 'none',
                      transition: 'all 0.2s ease',
                      transform: (isTestMode && !foundWords.includes(word)) ? 'scale(1.02)' : 'scale(1)'
                    }}
                    onMouseEnter={(e) => {
                      if (isTestMode && !foundWords.includes(word)) {
                        e.target.style.backgroundColor = isDarkMode ? 'rgba(34, 197, 94, 0.2)' : 'rgba(34, 197, 94, 0.1)';
                        e.target.style.transform = 'scale(1.05)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (isTestMode && !foundWords.includes(word)) {
                        e.target.style.backgroundColor = isDarkMode ? '#374151' : '#f9fafb';
                        e.target.style.transform = 'scale(1.02)';
                      }
                    }}
                  >
                    {foundWords.includes(word) ? '✅' : (isTestMode && !foundWords.includes(word) ? '🧪' : '🔍')} {word}
                    {isTestMode && !foundWords.includes(word) && (
                      <span style={{
                        fontSize: '0.6rem',
                        color: isDarkMode ? '#22c55e' : '#059669',
                        marginLeft: '0.3rem',
                        opacity: 0.8
                      }}>
                        clique
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Modal de definição da palavra */}
        {showDefinitionModal && selectedWordData && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: isMobile ? '1rem' : '2rem',
            animation: 'modalFadeIn 0.3s ease-out'
          }}>
            <div style={{
              backgroundColor: isDarkMode ? '#1f2937' : 'white',
              borderRadius: '20px',
              padding: isMobile ? '1.5rem' : '2.5rem',
              maxWidth: isMobile ? '95vw' : '900px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              border: `3px solid ${isDarkMode ? '#10b981' : '#059669'}`,
              position: 'relative',
              animation: 'modalSlideIn 0.4s ease-out'
            }}>
              {/* Confete decorativo */}
              <div style={{
                position: 'absolute',
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '2.5rem',
                animation: 'bounce 1s infinite'
              }}>
                🎉
              </div>

              {/* Botão fechar */}
              <button
                onClick={() => setShowDefinitionModal(false)}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'none',
                  border: 'none',
                  fontSize: '1.8rem',
                  cursor: 'pointer',
                  color: isDarkMode ? '#9ca3af' : '#6b7280',
                  padding: '0.5rem',
                  borderRadius: '50%',
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  zIndex: 10
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isDarkMode ? '#374151' : '#f3f4f6';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                ×
              </button>

              {/* Layout principal - flexível para desktop/mobile */}
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '1.5rem' : '2rem',
                alignItems: isMobile ? 'center' : 'flex-start'
              }}>
                
                {/* Coluna da imagem */}
                <div style={{
                  flex: isMobile ? 'none' : '1',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  {/* Imagem da palavra - agora maior */}
                  {selectedWordData.imagem && (
                    <div style={{
                      position: 'relative',
                      borderRadius: '15px',
                      overflow: 'hidden',
                      border: `3px solid ${isDarkMode ? '#10b981' : '#059669'}`,
                      boxShadow: '0 15px 35px -5px rgba(0, 0, 0, 0.3)',
                      animation: 'celebration 1s ease-out'
                    }}>
                      <img
                        src={selectedWordData.imagem}
                        alt={selectedWordData.word}
                        style={{
                          width: isMobile ? '280px' : '350px',
                          height: isMobile ? '400px' : '500px',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                      
                      {/* Overlay com ícone da palavra */}
                      <div style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                      }}>
                        {selectedWordData.icon}
                      </div>
                    </div>
                  )}
                </div>

                {/* Coluna das informações */}
                <div style={{
                  flex: isMobile ? 'none' : '1',
                  width: isMobile ? '100%' : 'auto'
                }}>
                  
                  {/* Card de congratulação */}
                  <div style={{
                    background: `linear-gradient(135deg, ${isDarkMode ? '#065f46' : '#dcfce7'}, ${isDarkMode ? '#047857' : '#bbf7d0'})`,
                    padding: '1.5rem',
                    borderRadius: '16px',
                    marginBottom: '1.5rem',
                    border: `2px solid ${isDarkMode ? '#10b981' : '#059669'}`,
                    boxShadow: '0 10px 25px -5px rgba(16, 185, 129, 0.2)',
                    textAlign: 'center',
                    animation: 'prize 0.6s ease-out'
                  }}>
                    {/* Troféu animado */}
                    <div style={{
                      fontSize: isMobile ? '2.5rem' : '3rem',
                      marginBottom: '0.5rem',
                      animation: 'prize 0.6s ease-out'
                    }}>
                      🏆
                    </div>
                    
                    {/* Texto PALAVRA ENCONTRADA */}
                    <h2 style={{
                      margin: 0,
                      color: isDarkMode ? '#6ee7b7' : '#047857',
                      fontSize: isMobile ? '1.2rem' : '1.4rem',
                      fontWeight: 'bold',
                      marginBottom: '1rem'
                    }}>
                      🎊 PALAVRA ENCONTRADA! 🎊
                    </h2>

                    {/* Botão com a palavra */}
                    <div style={{
                      backgroundColor: isDarkMode ? '#047857' : '#059669',
                      padding: '1rem 1.5rem',
                      borderRadius: '25px',
                      marginBottom: '1rem',
                      border: `2px solid ${isDarkMode ? '#10b981' : '#34d399'}`,
                      animation: 'celebration 1s ease-out infinite'
                    }}>
                      <span style={{
                        color: 'white',
                        fontSize: isMobile ? '1.4rem' : '1.6rem',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem'
                      }}>
                        ✨ {selectedWordData.word} ✨
                      </span>
                    </div>

                    {/* Pontuação */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      marginBottom: '0.5rem'
                    }}>
                      <span style={{ fontSize: '1.5rem' }}>⭐</span>
                      <span style={{
                        color: isDarkMode ? '#6ee7b7' : '#047857',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '1.1rem' : '1.3rem'
                      }}>
                        +100 pontos ganhos!
                      </span>
                      <span style={{ fontSize: '1.5rem' }}>⭐</span>
                    </div>
                    
                    {/* Progresso */}
                    <div style={{
                      color: isDarkMode ? '#10b981' : '#047857',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      fontWeight: '600'
                    }}>
                      {foundWords.length}/{words.length} palavras encontradas
                    </div>
                  </div>

                  {/* Card da Definição */}
                  <div style={{
                    backgroundColor: isDarkMode ? '#1e40af' : '#dbeafe',
                    padding: '1.5rem',
                    borderRadius: '16px',
                    marginBottom: '1.5rem',
                    border: `2px solid ${isDarkMode ? '#3b82f6' : '#2563eb'}`,
                    boxShadow: '0 8px 20px -5px rgba(59, 130, 246, 0.2)'
                  }}>
                    <h3 style={{
                      color: isDarkMode ? '#93c5fd' : '#1d4ed8',
                      fontSize: isMobile ? '1.2rem' : '1.3rem',
                      marginBottom: '1rem',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      📖 Definição:
                    </h3>
                    <p style={{
                      color: isDarkMode ? '#bfdbfe' : '#1e40af',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      lineHeight: '1.6',
                      margin: 0,
                      fontWeight: '500'
                    }}>
                      {selectedWordData.definition}
                    </p>
                  </div>

                  {/* Card da Explicação */}
                  <div style={{
                    backgroundColor: isDarkMode ? '#7c2d12' : '#fed7aa',
                    padding: '1.5rem',
                    borderRadius: '16px',
                    marginBottom: '2rem',
                    border: `2px solid ${isDarkMode ? '#ea580c' : '#ea580c'}`,
                    boxShadow: '0 8px 20px -5px rgba(234, 88, 12, 0.2)'
                  }}>
                    <h3 style={{
                      color: isDarkMode ? '#fdba74' : '#9a3412',
                      fontSize: isMobile ? '1.2rem' : '1.3rem',
                      marginBottom: '1rem',
                      fontWeight: '700',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      💡 Explicação:
                    </h3>
                    <p style={{
                      color: isDarkMode ? '#fed7aa' : '#7c2d12',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      lineHeight: '1.6',
                      margin: 0,
                      fontWeight: '500'
                    }}>
                      {selectedWordData.explanation}
                    </p>
                  </div>

                  {/* Botão de ação */}
                  <button
                    onClick={() => setShowDefinitionModal(false)}
                    style={{
                      width: '100%',
                      padding: isMobile ? '1.2rem' : '1.4rem',
                      backgroundColor: isDarkMode ? '#10b981' : '#059669',
                      color: 'white',
                      border: 'none',
                      borderRadius: '15px',
                      fontSize: isMobile ? '1.1rem' : '1.2rem',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      boxShadow: '0 8px 20px -5px rgba(16, 185, 129, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-3px)';
                      e.target.style.boxShadow = '0 12px 30px -5px rgba(16, 185, 129, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 8px 20px -5px rgba(16, 185, 129, 0.3)';
                    }}
                  >
                    🚀 Continue Jogando!
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Premium */}
        {showPremiumModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: isMobile ? '1rem' : '2rem',
            animation: 'modalFadeIn 0.3s ease-out'
          }}>
            <div style={{
              backgroundColor: isDarkMode ? '#1f2937' : 'white',
              borderRadius: '20px',
              padding: isMobile ? '2rem 1.5rem' : '3rem',
              maxWidth: isMobile ? '95vw' : '600px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              border: `3px solid #fbbf24`,
              position: 'relative',
              textAlign: 'center',
              animation: 'modalSlideIn 0.4s ease-out'
            }}>
              {/* Ícone Premium */}
              <div style={{
                fontSize: isMobile ? '3rem' : '4rem',
                marginBottom: '1rem',
                animation: 'bounce 2s infinite'
              }}>
                👑
              </div>

              {/* Título */}
              <h2 style={{
                fontSize: isMobile ? '1.8rem' : '2.2rem',
                marginBottom: '1rem',
                color: isDarkMode ? '#fbbf24' : '#f59e0b',
                fontWeight: 'bold'
              }}>
                Acesso Premium Necessário
              </h2>

              {/* Mensagem principal */}
              <p style={{
                fontSize: isMobile ? '1.1rem' : '1.3rem',
                marginBottom: '1.5rem',
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                lineHeight: '1.6'
              }}>
                Esta funcionalidade é exclusiva para membros Premium! 
                Desbloqueie acesso completo a todos os jogos e recursos especiais.
              </p>

              {/* Lista de benefícios */}
              <div style={{
                backgroundColor: isDarkMode ? '#374151' : '#f9fafb',
                padding: '1.5rem',
                borderRadius: '12px',
                marginBottom: '2rem',
                textAlign: 'left'
              }}>
                <h3 style={{
                  fontSize: isMobile ? '1.1rem' : '1.2rem',
                  marginBottom: '1rem',
                  color: isDarkMode ? '#fbbf24' : '#f59e0b',
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}>
                  ✨ Com o Premium você tem:
                </h3>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0
                }}>
                  <li style={{
                    padding: '0.5rem 0',
                    color: isDarkMode ? '#d1d5db' : '#4b5563',
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    🎮 <span>Acesso ilimitado a todos os jogos</span>
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    color: isDarkMode ? '#d1d5db' : '#4b5563',
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    🔄 <span>Renovação ilimitada de palavras cruzadas</span>
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    color: isDarkMode ? '#d1d5db' : '#4b5563',
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    📚 <span>Conteúdo exclusivo e temas especiais</span>
                  </li>
                  <li style={{
                    padding: '0.5rem 0',
                    color: isDarkMode ? '#d1d5db' : '#4b5563',
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    🎁 <span>Recursos premium e recompensas especiais</span>
                  </li>
                </ul>
              </div>

              {/* Botões */}
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: '1rem',
                justifyContent: 'center'
              }}>
                <button
                  onClick={() => window.open('https://dropsebook.com/premium', '_blank')}
                  style={{
                    background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: isMobile ? '1rem 2rem' : '1.2rem 2.5rem',
                    fontSize: isMobile ? '1.1rem' : '1.3rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 20px -5px rgba(251, 191, 36, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 12px 30px -5px rgba(251, 191, 36, 0.5)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 8px 20px -5px rgba(251, 191, 36, 0.4)';
                  }}
                >
                  👑 Assinar Premium
                </button>

                <button
                  onClick={() => setShowPremiumModal(false)}
                  style={{
                    background: 'transparent',
                    color: isDarkMode ? '#9ca3af' : '#6b7280',
                    border: `2px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
                    borderRadius: '12px',
                    padding: isMobile ? '1rem 2rem' : '1.2rem 2.5rem',
                    fontSize: isMobile ? '1rem' : '1.1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = isDarkMode ? '#374151' : '#f3f4f6';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                  }}
                >
                  ← Voltar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de vitória */}
        {gameComplete && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start', // Mudança aqui para alinhar no topo
            zIndex: 999,
            padding: isMobile ? '1rem' : '2rem',
            overflowY: 'auto' // Permitir scroll vertical
          }}>
            <div style={{
              backgroundColor: isDarkMode ? '#1f2937' : 'white',
              padding: isMobile ? '2rem 1.5rem' : '3rem',
              borderRadius: '12px',
              textAlign: 'center',
              maxWidth: isMobile ? '90%' : '500px', // Aumentei um pouco a largura máxima
              width: '100%',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
              margin: isMobile ? '1rem auto' : '2rem auto', // Margem automática para centralizar
              maxHeight: isMobile ? 'calc(100vh - 2rem)' : 'calc(100vh - 4rem)', // Altura máxima
              overflowY: 'auto' // Scroll interno se necessário
            }}>
              <div style={{ fontSize: isMobile ? '3rem' : '4rem', marginBottom: '1rem' }}>🎉</div>
              
              <h2 style={{
                fontSize: isMobile ? '1.5rem' : '2rem',
                marginBottom: '1rem',
                color: isDarkMode ? '#10b981' : '#059669'
              }}>
                Parabéns!
              </h2>
              
              <p style={{ 
                marginBottom: '1.5rem',
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                fontSize: isMobile ? '1rem' : '1.1rem'
              }}>
                {themeData?.theme?.ui_settings?.celebration_message || `Você encontrou todas as ${words.length} palavras!`}
              </p>

              {/* Vídeo de recompensa */}
              {themeData?.theme?.completion_reward?.type === 'video' && (
                <div style={{
                  marginBottom: '2rem',
                  padding: '1rem',
                  backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                  borderRadius: '8px',
                  border: `2px solid ${isDarkMode ? '#10b981' : '#059669'}`
                }}>
                  <h3 style={{
                    fontSize: isMobile ? '1.1rem' : '1.3rem',
                    marginBottom: '0.5rem',
                    color: isDarkMode ? '#10b981' : '#059669'
                  }}>
                    🎁 {themeData.theme.completion_reward.title}
                  </h3>
                  
                  <p style={{
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    marginBottom: '1rem',
                    color: isDarkMode ? '#d1d5db' : '#4b5563'
                  }}>
                    {themeData.theme.completion_reward.description}
                  </p>

                  <video 
                    controls 
                    style={{
                      width: '100%',
                      maxWidth: '300px',
                      borderRadius: '6px'
                    }}
                    poster="https://dropsebook.com/imagens/premium_drop_02.jfif"
                  >
                    <source src={themeData.theme.completion_reward.url} type="video/mp4" />
                    Seu navegador não suporta a reprodução de vídeo.
                  </video>
                </div>
              )}
              
              <div style={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row',
                gap: '1rem', 
                justifyContent: 'center' 
              }}>
                {/* Botão Próximo Tema - só aparece se houver próximo tema */}
                {getNextTheme() && (
                  <button 
                    onClick={goToNextTheme}
                    style={{
                      padding: '0.75rem 1.5rem',
                      backgroundColor: isDarkMode ? '#10b981' : '#059669',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)' // Destaque especial
                    }}
                  >
                    ➡️ Próximo Tema
                  </button>
                )}
                
                <button 
                  onClick={resetGame}
                  style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: isDarkMode ? '#4f46e5' : '#4338ca',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: isMobile ? '0.9rem' : '1rem'
                  }}
                >
                  🔄 Jogar Novamente
                </button>
                
                <button 
                  onClick={() => navigate('/')}
                  style={{
                    padding: '0.75rem 1.5rem',
                    backgroundColor: isDarkMode ? '#374151' : '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: isMobile ? '0.9rem' : '1rem'
                  }}
                >
                  🏠 Voltar ao Início
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Nota: TesteCruzadas agora usa um gerador com as mesmas direções
// suportadas pelo verificador abaixo (H, HR, V, VR). Isso mantém
// o contrato de detecção alinhado entre projetos.

export default BiblicalCrossword;
